import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-v3-add-adhoc-veh',
  templateUrl: './v3-add-adhoc-veh.component.html',
  styleUrls: ['./v3-add-adhoc-veh.component.scss']
})
export class V3AddAdhocVehComponent {

  _mVehicleTypes: any[] = [];
  _mDriversData: any[] = [];
  registrationNo: any = '';
  vehicleType: any = '';
  mapToExistingDriver: boolean = false;
  driverName: any = '';
  licenseNumber: any = '';
  contactNumber: any = '';
  mVendorMasters: any = '';
  _mVMData: any = [];
  _mSitesData: any;
  site: any = '';

  constructor(
    public dialogRef: MatDialogRef<V3AddAdhocVehComponent>,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngxLoader: NgxUiLoaderService) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getActiveSites();
    this.getVehicleTypes();
    setTimeout(() => {
      this.getAllVendor();
    }, 300);
  }

  getVehicleTypes() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleType, success => {
      if (success.status == 200) {
        this._mVehicleTypes = success.body;
        this._mVehicleTypes = this._mVehicleTypes.filter(
          vehicletype => vehicletype.status == AppConstants.ACTIVE_STATUS
        );
      }
    }, error => {
      console.log(error);
    });
  }

  discard_special_char_And_String(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || (k === 32));
  }

  discard_special_char(event) {
    var k;
    k = event.charCode;
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  onStatusChange() {
    this.driverName = '';
    this.mVendorMasters = '';
    this._mDriversData = [];
    this.licenseNumber = '';
    this.contactNumber = '';
  }

  omit_special_char_And_num(event) {
    let k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  getAllVendor() {
    if(this.site)
    {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVendorMaserBasedOnId + this.site,
      success => {
        if (success != null) {
          this._mVMData = success.body;
        } else {
          this._mVMData = [];
          this.notifyService.showInfo("No vendors master data found", null);
        }
      },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }
  }

  getDriverDetails(event) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getByvendor + event.target.value, (success) => {
      if (success.status == 200) {
        this._mDriversData = success.body;
      } else {
        this._mDriversData = [];
        this.notifyService.showWarning("No drivers found", null);
      }
    },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  onSelectDriver(event) {
    const driver = this._mDriversData.find(ele => ele.id == event.target.value);
    if (driver) {
      this.licenseNumber = driver.licenseNumber;
      this.contactNumber = driver.contactNumber;
    }
  }

  onConfirmation() {
    let sendData: any = '';
    if (this.mapToExistingDriver) {
      sendData = {
        "vehicleTypeId": this.vehicleType,
        "registrationNo": this.registrationNo,
        "siteId": this.site,
        "vendorMasterId": this.mVendorMasters,
        "driverId": this.driverName,
        "mapToExistingDriver": this.mapToExistingDriver
      }
    } else {
      sendData = {
        "vehicleTypeId": this.vehicleType,
        "registrationNo": this.registrationNo,
        "siteId": this.site,
        "vendorMasterId": this.mVendorMasters,
        "driverName": this.driverName,
        "licenseNumber": this.licenseNumber,
        "contactNumber": this.contactNumber,
        "mapToExistingDriver": this.mapToExistingDriver
      }
    }
    if (sendData) {
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(ApiConstants.addOutSourceVehicle, sendData, (success) => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          if (success.body.message == 'Added successfully') {
            this.dialogRef.close("");
            this.notifyService.showSuccess(success.body.message, null);
          } else {
            this.notifyService.showWarning(success.body.message, null);
          }
        }
      }, (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError("Failed to add", null);
      });
    }
  }

  getActiveSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getsitesbyuserid,
      success => {
        if (success.status == 200) {
          this._mSitesData = success.body;
        } else {
          this._mSitesData = [];
        }
      }, (error) => {
      })
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }
}